import { useEffect, useState, useContext } from "react";
import UserDataDesktop from "../../common/userInfo/UserDataDesktop";
import UserDataMobile from "../../common/userInfo/UserDataMobile";
import { GET } from "../../utils/fetchUtil";
import { MessageContext } from "../../common/message/index";
import { useTranslation } from "react-i18next";
import Loader from "../../common/loader/Loader";

const RequestUserDataPage = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const message = useContext(MessageContext);
  const [data, setData] = useState(null);
  const { t } = useTranslation();
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    GET(
      "/info",
      (requests) => {
        setData(requests);
      },
      (error) => {
        message.toggle({
          title: t("requests.overview.supplement.infoBar.errorTitle"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, []);

  const isMobile = width <= 960;

  if (data) {
    if (isMobile) {
      return <UserDataMobile data={data} />;
    } else {
      return <UserDataDesktop data={data} />;
    }
  } else {
    return <Loader size={`8x`} className="is-flex-grow-1 is-align-self-center" />;
  }
};

export default RequestUserDataPage;
